<div class="container py-5">
  <!-- Header Section -->
  <div class="d-flex justify-content-between align-items-center mb-5">
    <h2 class="fw-bolder mb-3 mb-md-0">Choose the right plan for your business</h2>
    <!-- Bootstrap Button Group for the toggle -->
    <div class="btn-group" role="group">
      <button
        type="button"
        class="btn btn-toggle"
        [class.active]="billingCycle === 'Monthly'"
        (click)="setBillingCycle('Monthly')"
      >
        Monthly
      </button>
      <button
        type="button"
        class="btn btn-toggle"
        [class.active]="billingCycle === 'Yearly'"
        (click)="setBillingCycle('Yearly')"
      >
        Yearly
      </button>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Plans Grid -->
  <div *ngIf="!isLoading">
    <!-- Monthly Plans -->
    <div class="row g-4" *ngIf="billingCycle === 'Monthly'">
      <div class="col-lg-4 col-md-4" *ngFor="let plan of monthlyPlans">
        <app-plan-card
          [plan]="plan"
          [isCurrentPlan]="plan.id === (currentSubscription$ | async)?.planId"
          [currentPlan]="currentSubscription$ | async"
          (planSelected)="handlePlanSelection($event)"
          [class.selected-plan]="plan.id === selectedPlanId"
        >
        </app-plan-card>
      </div>
    </div>

    <!-- Yearly Plans -->
    <div class="row g-4" *ngIf="billingCycle === 'Yearly'">
      <div class="col-lg-4 col-md-4" *ngFor="let plan of yearlyPlans">
        <app-plan-card
          [plan]="plan"
          [isCurrentPlan]="plan.id === (currentSubscription$ | async)?.planId"
          [currentPlan]="currentSubscription$ | async"
          (planSelected)="handlePlanSelection($event)"
          [class.selected-plan]="plan.id === selectedPlanId"
        >
        </app-plan-card>
      </div>
    </div>
  </div>
</div>
